import _extends from '@babel/runtime-corejs3/helpers/extends';
import React from 'react';
import { TUXNavBar } from '../TUXNavBar/TUXNavBar.js';
import { TUXProvider } from '../TUXProvider/TUXProvider.js';

/**
 * TUXTitleBar is a special type of TUXNavBar which is used in TUXSheet. It has fixed 52px height.
 */
var TUXTitleBar = function TUXTitleBar(props) {
  return /*#__PURE__*/React.createElement(TUXProvider, {
    navBarHeight: 52
  }, /*#__PURE__*/React.createElement(TUXNavBar, _extends({
    backgroundColor: "BGSecondary"
  }, props)));
};

export { TUXTitleBar };
//# sourceMappingURL=TUXTitleBar.js.map
